import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import Breadcrumb from "../../common/header/Breadcrumb";
import Header from "../../common/header/Header";
import PaymentMadeTemplate from '../../components/NotificationSettings/PaymentMadeTemplate'

const PaymentMade = () => {
   useEffect(() => {
            window.scrollTo(0, 0);
        }, []);
  return (
    <>
      <Box sx={{ flexGrow: 1 }} className="page-background">
        <Header />
        <Breadcrumb />
        <PaymentMadeTemplate/>
      </Box>
    </>
  )
}

export default PaymentMade